import { EventType, User } from "@/types";

import { axios } from "../axios.instance";

export type RemoveParticipantsBulkRequest = {
  eventId: EventType["id"];
  participantIds: User["id"][];
};

export type RemoveParticipantsBulkResponse = unknown;

export const removeParticipantsBulk = async (
  body: RemoveParticipantsBulkRequest
): Promise<RemoveParticipantsBulkResponse> => {
  const { data } = await axios.post(`/events/manage/${body.eventId}/remove-multiple`, {
    participantIds: body.participantIds,
  });

  return data;
};
